export default __webpack_public_path__ + "asset/img/shop-logo/2~ed3eb67f.png";